import React from 'react';

import Breadcrumbs from '../components/Breadcrumbs';

const Breadcrumb = (props: any) => {
    const newProps = { ...props };

    return <Breadcrumbs {...newProps} />;
}

export default Breadcrumb;
